import React from 'react';
import Layout from '../components/Layout';
import { Categories } from '../components/SideMenu/Categories';
import Helmet from 'react-helmet';
import { graphql } from 'gatsby';

const CategoriesRoute: React.FC = (props) => {
  const { title } = props.data.site.siteMetadata;
  return (
    <Layout>
      <Helmet title={`Categories - ${title}`} />
      <Categories />
    </Layout>
  );
};

export default CategoriesRoute;

export const pageQuery = graphql`
  query CategoriesRouteQuery {
    site {
      siteMetadata {
        title
        subtitle
      }
    }
  }
`;
